import { render, staticRenderFns } from "./joinUsDetail.vue?vue&type=template&id=630cacaf&scoped=true&"
import script from "./joinUsDetail.vue?vue&type=script&lang=js&"
export * from "./joinUsDetail.vue?vue&type=script&lang=js&"
import style0 from "./joinUsDetail.vue?vue&type=style&index=0&id=630cacaf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630cacaf",
  null
  
)

export default component.exports